import React from 'react'
import clsx from 'clsx'
import {useGetAdaptiveStyle} from 'uikit'
import {config} from 'src/config'
import {useAppSelector} from 'store'
import {getCountOfError} from 'store/secretword/selectors'
import styles from './gallow.scss'

const Gallow = () => {
  const countOfErrors: number = useAppSelector(getCountOfError)
  const {widthSize, heightSize} = useGetAdaptiveStyle([])
  const isSmall = ['sm','xs','xxs'].includes(heightSize)
    || ['sm', 'xs', 'xxs'].includes(widthSize)

  return (
    <div className={clsx(isSmall ? styles.wrapS : styles.wrap)}>
        {countOfErrors < 1 && <div className={clsx(isSmall ? styles.greyHeadElementS :styles.greyHeadElement)}></div>}
        {countOfErrors < 2 && <div className={clsx(isSmall ? styles.greyBodyElementS : styles.greyBodyElement)}></div>}
        {countOfErrors < 3 && <div className={clsx(isSmall ? styles.greyLeftLegElementS : styles.greyLeftLegElement)}></div>}
        {countOfErrors < 4 && <div className={clsx(isSmall ? styles.greyRightLegElementS : styles.greyRightLegElement)}></div>}
        {countOfErrors < 5 && <div className={clsx(isSmall ? styles.greyLeftHandElementS : styles.greyLeftHandElement)}></div>}
        {countOfErrors < 6 && <div className={clsx(isSmall ? styles.greyRightHandElementS : styles.greyRightHandElement)}></div>}
        {countOfErrors < 7 && <div className={clsx(isSmall ? styles.greyGallowsFoundElementS : styles.greyGallowsFoundElement)}></div>}
        {countOfErrors < config.countGuessAttempts-1 && (
          <div className={clsx(isSmall ? styles.greyGallowsElementS : styles.greyGallowsElement)}></div>
        )}
        {countOfErrors < config.countGuessAttempts && (
          <div className={clsx(isSmall ? styles.greyGallowsArmElementS : styles.greyGallowsArmElement)}></div>
        )}
        {countOfErrors < config.countGuessAttempts+1 && (
          <div className={clsx(isSmall ? styles.greyGallowsRopeElementS : styles.greyGallowsRopeElement)}></div>
        )}
        {countOfErrors > 0 && <div className={clsx(isSmall ? styles.headElementS : styles.headElement)}></div>}
        {countOfErrors > 1 && <div className={clsx(isSmall ? styles.bodyElementS : styles.bodyElement)}></div>}
        {countOfErrors > 2 && <div className={clsx(isSmall ? styles.leftLegElementS : styles.leftLegElement)}></div>}
        {countOfErrors > 3 && <div className={clsx(isSmall ? styles.rightLegElementS : styles.rightLegElement)}></div>}
        {countOfErrors > 4 && <div className={clsx(isSmall ? styles.leftHandElementS : styles.leftHandElement)}></div>}
        {countOfErrors > 5 && <div className={clsx(isSmall ? styles.rightHandElementS : styles.rightHandElement)}></div>}
        {countOfErrors > 6 && <div className={clsx(isSmall ? styles.gallowsFoundElementS : styles.gallowsFoundElement)}></div>}
        {countOfErrors > 7 && <div className={clsx(isSmall ? styles.gallowsElementS : styles.gallowsElement)}></div>}
        {countOfErrors > config.countGuessAttempts-1 && (
          <div className={clsx(isSmall ? styles.gallowsArmElementS : styles.gallowsArmElement)}></div>
        )}                            
        {countOfErrors > config.countGuessAttempts && (
          <div className={clsx(isSmall ? styles.gallowsRopeElementS : styles.gallowsRopeElement)}></div>
        )}
    </div>
  )
}

export default Gallow
